<template>
  <v-form ref="form" class="discount-data-form">
    <v-combobox
      v-model="city"
      @change="fetchCityStores"
      :items="cityItems"
      label="Stadt"
      required
    ></v-combobox>

    <v-combobox
      v-model="store"
      v-if="storeInputVisible"
      :items="storeItems"
      label="Geschäft"
      required
    ></v-combobox>

    <section v-if="dataInputsVisible">
      <v-file-input
        ref="logoInput"
        :rules="logoRules"
        @change="logo = $event"
        id="logo"
        label="Logo (max. 500 KB)"
        show-size
        required
      ></v-file-input>
      <v-img v-if="logo" class="logo" :src="logo" contain />
      <v-text-field v-model="title" label="Titel" required></v-text-field>
      <v-textarea
        v-model="description"
        label="Beschreibung"
        required
      ></v-textarea>
      <v-row justify="space-around">
        <v-date-picker
          v-model="start"
          :min="currentDate"
          color="green"
        ></v-date-picker>
        <v-date-picker
          v-model="end"
          :min="start || currentDate"
          color="red"
        ></v-date-picker>
      </v-row>
    </section>
  </v-form>
</template>

<style lang="scss" scoped>
.logo {
  display: block;
  margin-bottom: 1.5rem;
  max-width: 100%;
  max-height: 5rem;
}
</style>

<script>
export default {
  name: "DiscountDataForm",

  data: () => ({
    currentDate: new Date().toISOString().substr(0, 10),

    logoRules: [
      value =>
        !value ||
        value.size < 500000 ||
        "Das Logo darf maximal 500 KB groß sein!"
    ]
  }),

  computed: {
    cityItems: function() {
      return this.$store.getters["cities/all"]().map(city => {
        return {
          text: `${city.name} | ${city.location.federalState}`,
          value: city._id
        };
      });
    },
    storeItems: function() {
      return this.city == null
        ? []
        : this.$store.getters["stores/byCity"](this.city.value).map(store => {
            return {
              text: `${store.name} | ${store.location.street} ${store.location.houseNumber}`,
              value: store._id
            };
          });
    },

    storeInputVisible: function() {
      return this.cityItems.find(v => v === this.city) != null;
    },
    dataInputsVisible: function() {
      return (
        this.storeInputVisible &&
        this.storeItems.find(v => v === this.store) != null
      );
    },

    city: {
      get() {
        let item = this.cityItems.find(
          v => v.value === this.$store.state.discountEditor.cityId
        );
        return item === undefined ? null : item;
      },
      set(item) {
        this.$store.commit(
          "discountEditor/setCity",
          item == null ? null : item.value
        );
      }
    },
    store: {
      get() {
        let item = this.storeItems.find(
          v => v.value === this.$store.state.discountEditor.data.storeId
        );
        return item === undefined ? null : item;
      },
      set(item) {
        this.$store.commit(
          "discountEditor/setStore",
          item == null ? null : item.value
        );
      }
    },

    logo: {
      get() {
        return this.$store.state.discountEditor.data.logo;
      },
      set(imageFile) {
        this.$refs.form.validate();
        if (this.$refs.logoInput.valid === true) {
          this.$parseImage(imageFile).then(result =>
            this.$store.commit("discountEditor/setLogo", result)
          );
        }
      }
    },
    title: {
      get() {
        return this.$store.state.discountEditor.data.title;
      },
      set(value) {
        this.$store.commit("discountEditor/setTitle", value);
      }
    },
    description: {
      get() {
        return this.$store.state.discountEditor.data.description;
      },
      set(value) {
        this.$store.commit("discountEditor/setDescription", value);
      }
    },
    start: {
      get() {
        return this.$store.state.discountEditor.data.start;
      },
      set(value) {
        this.$store.commit("discountEditor/setStart", value);
      }
    },
    end: {
      get() {
        return this.$store.state.discountEditor.data.end;
      },
      set(value) {
        this.$store.commit("discountEditor/setEnd", value);
      }
    }
  },

  methods: {
    fetchCityStores: function() {
      if (this.city === null) {
        this.store = null;
      } else {
        this.$store.dispatch("stores/fetchOne", this.city.value);
      }
    }
  },

  created() {
    this.$store.dispatch("cities/fetchAll");
  }
};
</script>
